"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemFormConfig = require("@/api/systemFormConfig");
var _wxApi = require("@/api/wxApi");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      subscribeTemplateInfo: {},
      levelLists: [],
      loadingList: false,
      centerDialogVisible: false,
      form: {
        id: '',
        isRoutine: null,
        routineId: ''
      },
      subscribeList: [] // 订阅模板列表
    };
  },
  created: function created() {
    this.subscribeTemplateInfo = {};
    // 固定获取微信订阅消息配置
    this.getNotificationList(1);
    this.loadSubscribeList();
  },
  methods: {
    // 加载订阅模板列表
    loadSubscribeList: function loadSubscribeList() {
      var _this = this;
      (0, _systemFormConfig.getWechatSubscribeList)().then(function (res) {
        _this.subscribeList = res || [];
      }).catch(function (err) {
        console.error('加载订阅模板列表失败:', err);
        _this.subscribeList = [];
      });
    },
    // 获取消息列表
    getNotificationList: function getNotificationList(id) {
      var _this2 = this;
      this.loadingList = true;
      (0, _systemFormConfig.notificationListApi)({
        sendType: id
      }).then(function (res) {
        _this2.loadingList = false;
        _this2.levelLists = res;
      }).catch(function () {
        _this2.loadingList = false;
      });
    },
    // 小程序消息开关
    changeRoutine: function changeRoutine(row) {
      var _this3 = this;
      (0, _systemFormConfig.notificationRoutine)(row.id).then(function () {
        _this3.$modal.msgSuccess("修改成功");
      });
    },
    // 模板选择变更
    handleTemplateChange: function handleTemplateChange(value) {
      var item = this.subscribeList.find(function (item) {
        return item.id == value;
      });
      this.subscribeTemplateInfo = item || {};
    },
    // 获取详情
    getNotificationDetail: function getNotificationDetail() {
      var _this4 = this;
      var data = {
        id: this.id,
        type: 'routine'
      };
      (0, _systemFormConfig.notificationDetail)(data).then(function (res) {
        _this4.form = res;
        _this4.$set(_this4.form, 'isRoutine', res.isRoutine.toString());
        if (_this4.form.routineId) {
          _this4.subscribeTemplateInfo = _this4.subscribeList.find(function (item) {
            return item.id == _this4.form.routineId;
          }) || {};
        }
      });
    },
    // 设置
    setting: function setting(row) {
      this.subscribeTemplateInfo = {};
      this.id = row.id;
      this.centerDialogVisible = true;
      this.loadSubscribeList();
      this.getNotificationDetail();
    },
    // 修改通知
    submit: (0, _validate.Debounce)(function () {
      var _this5 = this;
      var data = {
        id: this.id,
        isRoutine: Number(this.form.isRoutine),
        routineId: this.form.routineId
      };
      (0, _systemFormConfig.notificationUpdate)(data).then(function () {
        _this5.$modal.msgSuccess("修改成功");
        _this5.centerDialogVisible = false;
        _this5.getNotificationList(1);
      });
    }),
    syncRoutine: function syncRoutine() {
      var _this6 = this;
      (0, _wxApi.routineAsyncApi)().then(function () {
        _this6.$message.success('同步成功');
      });
    }
  }
};